import { createFileRoute } from '@tanstack/react-router';

import {
  communicationSettingListScreen,
  communicationSettingSearch,
  loadCommunicationSettingMessages,
  loadCommunicationSettingScreen,
} from '@/modules/communication-setting/route';
import { lazyScreen } from '@/shared/screen';

// Régua de comunicação no caminho do legado (`router.tsx:1434-1438`): o menu passa a apontar para cá
// quando o manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/gestao-carteira/regua/')({
  validateSearch: communicationSettingSearch,
  staticData: { screen: communicationSettingListScreen },
  loader: () => loadCommunicationSettingMessages(),
  component: lazyScreen(() => loadCommunicationSettingScreen().then((module) => ({ default: module.CommunicationSettingRouteScreen }))),
});
